import axios from 'axios';
import { useProcessId, useRouter } from 'common-react';
import _ from 'lodash';
import React, { FunctionComponent, Suspense, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Provider, useDispatch } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { PageNotFound } from 'ui-components';
import { loadConfig } from '../../model/Config';
import store, { productWizardActions } from '../../model/store';
import FormikInit from '../formik/FormikInit/FormikInit';
import ProductWizardInit from './ProductWizardInit/ProductWizardInit';
import Screen from './Screen';

const ProductWizardContent : FunctionComponent<{
}> = () => {

  const { match } = useRouter();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  const processId = useProcessId();

  useEffect(() => {
    if (!processId) {
      return;
    }
    const configPromise = loadConfig();
    const fundsPromise = axios.get('/api/funds', { params: { registration: true } });
    const fundTypePromise = axios.get('/api/funds/fund-types');
    const riskPromise = axios.get('/api/funds/risks');
    const horizonPromise = axios.get('/api/funds/horizons');
    const umbrellaPromise = axios.get('/api/funds/umbrellas');
    const currentLimitsPromise = axios.get('/api/funds/currentLimit');
    const blockedFundsPromise = axios.get('/api/moventum/products/all/funds/blocked');
    const unitCategoriesPromise = axios.get('/api/funds/unit-categories');
    Promise
        .all([configPromise, fundsPromise, fundTypePromise, riskPromise, horizonPromise, umbrellaPromise, currentLimitsPromise, blockedFundsPromise, unitCategoriesPromise])
        .then(([config, fundsResponse, fundTypeResponse, riskResponse, horizonResponse, umbrellaResponse, currentLimitsResponse, blockedFundsResponse, unitCategoriesResponse]) => {
          dispatch(productWizardActions.setConfig(config));
          dispatch(productWizardActions.setApiState({
            funds: fundsResponse.data,
            fundTypes: fundTypeResponse.data,
            risks: riskResponse.data,
            horizons: horizonResponse.data,
            umbrellas: umbrellaResponse.data,
            currentLimits: currentLimitsResponse.data,
            blockedFundIdns: blockedFundsResponse.data,
            unitCategories: unitCategoriesResponse.data,
          }));
          setLoading(false);
        });
  }, [dispatch, processId]);

  const [url] = useTranslation('url');

  const ready = !_.isEmpty(processId) && !loading;

  return (
    <>
      {ready &&
      <Suspense fallback="">
        <FormikInit>
        <Switch>
          <Route exact path={match.path} component={ProductWizardInit}/>
          {Screen.ALL.map(screen =>
              <Route key={screen.code} path={`${match.path}/${url(screen.code)}`} component={screen.component}/>
          )}
          <Route component={PageNotFound} />
        </Switch>
        </FormikInit>
      </Suspense>}
    </>
  );
};

const ProductWizard : FunctionComponent<{
}> = () => {
  return (
    <Provider store={store}>
      <ProductWizardContent/>
    </Provider>
  );
};

export default ProductWizard;
